import { render, staticRenderFns } from "./StudentAttendance.vue?vue&type=template&id=19354d72&scoped=true"
import script from "./StudentAttendance.vue?vue&type=script&lang=js"
export * from "./StudentAttendance.vue?vue&type=script&lang=js"
import style0 from "./StudentAttendance.vue?vue&type=style&index=0&id=19354d72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19354d72",
  null
  
)

export default component.exports